import {Box, Divider, Drawer, useMediaQuery} from '@mui/material';
import {NavItem} from './nav-item';
import logo from "../assets/logo.png"
import {NavItemMulti} from "./nav-item-multi";


export const DashboardSidebar = (props: any) => {
    const {open, onClose, items} = props;
    const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up('lg'), {
        defaultMatches: true,
        noSsr: false
    });

    const content = (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                }}
            >
                <div
                    style={{
                        padding: '12px 0',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    }}
                >
                    <a href="/">
                        <img
                            alt="Logo"
                            src={logo}
                            style={{
                                maxWidth: '180px',
                                maxHeight: '55px',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain',
                                display: 'block',
                            }}
                        />
                    </a>
                </div>
                <Divider
                    sx={{
                        borderColor: '#2D3748',
                        my: 1
                    }}
                />
                <Box sx={{flexGrow: 1}}>
                    {items.map((item: any) => {
                        if(!item.sub_menus){
                            return <NavItem
                                key={item.title}
                                icon={item.icon}
                                href={item.href}
                                title={item.title}
                            />
                        }else {
                            return <NavItemMulti
                                key={item.title}
                                icon={item.icon}
                                href={item.href}
                                title={item.title}
                                submenus={item.sub_menus}
                            />
                        }

                        }
                    )}


                </Box>
                <Divider sx={{borderColor: '#2D3748'}}/>
            </Box>
        </>
    );

    if (lgUp) {
        return (
            <Drawer
                anchor="left"
                open
                PaperProps={{
                    sx: {
                        backgroundColor: '#D2E3FC',
                        color: '#FFFFFF',
                        width: 280
                    }
                }}
                variant="permanent"
            >
                {content}
            </Drawer>
        );
    }

    return (
        <Drawer
            anchor="left"
            onClose={onClose}
            open={open}
            PaperProps={{
                sx: {
                    backgroundColor: '#D2E3FC',
                    color: '#FFFFFF',
                    width: 280
                }
            }}
            sx={{zIndex: (theme) => theme.zIndex.appBar + 100}}
            variant="temporary"
        >
            {content}
        </Drawer>
    );
};
